import i18n from "i18next";

export type LinkType = "epay" | "partner" | "content" | "greencard";

export type ObjectWithLink = {
    links?: MyBrokerApi.HateoasLink[];
};
export const getLink = <T extends ObjectWithLink>(item: T, linkType: LinkType): MyBrokerApi.HateoasLink => {
    return item?.links?.find?.((l) => l.rel === linkType);
};

export type ObjectWithPartnerLink = ObjectWithLink & {
    insurer?: MyBrokerApi.Company;
};

export type InsurerLink = {
    link: string;
    label: string;
};

const insurerLinkNames: LinkType[] = ["epay", "partner", "greencard"];

export const getInsurerLinks = <T extends ObjectWithPartnerLink>(item: T): InsurerLink[] => {
    const insurerName = item?.insurer?.name;
    const insurerLinks: InsurerLink[] = [];

    for (const linkName of insurerLinkNames) {
        const link = getLink(item, linkName);
        if (link?.href) {
            const insurerLink = {
                link: link.href,
                label: i18n.t("ContractsItem.PartnerLink", { insurer: link?.text || insurerName }),
            };
            insurerLinks.push(insurerLink);
        }
    }

    return insurerLinks;
};
